import { create } from "zustand";
import { axiosInstance } from "../lib/axios";
import toast from "react-hot-toast";

export interface ErpEmployee {
  erpId: string | null;
  employeeId: string | null;
  fullName: string;
  email: string;
  netSalary: number;
  workingDays: number;
  monthlyWorkingDays: number;
  monthlyHours: number;
  perHourPKR: number;
  perHourUSD: number;
}

export interface ErpCostMeta {
  hoursPerDay: number;
  usdPkrRate: number;
  configured: boolean;
}

interface State {
  employees: ErpEmployee[];
  meta: ErpCostMeta | null;
  configured: boolean;
  loading: boolean;
  fetchEmployees: () => Promise<void>;
}

export const useErpEmployeesStore = create<State>((set) => ({
  employees: [],
  meta: null,
  configured: false,
  loading: false,

  fetchEmployees: async () => {
    set({ loading: true });
    try {
      const { data } = await axiosInstance.get("/erp/employees");
      set({
        employees: data.employees || [],
        meta: data.meta || null,
        configured: Boolean(data.configured),
      });
      if (data.error) toast.error("ERP employees fetch had an error (showing cached/empty).");
    } catch (err: any) {
      toast.error(err?.response?.data?.message || "Failed to load ERP employees");
    } finally {
      set({ loading: false });
    }
  },
}));
